import type { ValidationError } from './types'
import type { BetroffenePersonen } from '@/types/studyTypes'

export function validateBetroffenePersonen(d: BetroffenePersonen): ValidationError[] {
  const errors: ValidationError[] = []

  if (!d.personenGruppen?.trim())
    errors.push({ field: 'personenGruppen', message: 'Personengruppen ist ein Pflichtfeld.' })

  if (!d.personenGruppenTyp?.length)
    errors.push({ field: 'personenGruppenTyp', message: 'Bitte mindestens einen Typ wählen.' })

  if (d.erwarteteFaelleKlinik === undefined || d.erwarteteFaelleKlinik === null)
    errors.push({
      field: 'erwarteteFaelleKlinik',
      message: 'Erwartete Fallzahl (Klinik) ist ein Pflichtfeld.',
    })

  if (d.rechteEingeschraenkt && !d.rechteEingeschraenktGrund?.trim())
    errors.push({
      field: 'rechteEingeschraenktGrund',
      message: 'Begründung für Rechteeinschränkung ist erforderlich.',
    })

  return errors
}
